export default __webpack_public_path__ + "static/media/likert-face-3.59b6a841.svg";